module.exports = __webpack_public_path__ + "img/French_cote_logo_09.1b0d351d.png";